<template>
  <div v-if="loading" class="spinner-container">
    <div class="spinner"></div>
  </div>
  <div v-else>
    <div class="homepage d-flex flex-column vh-100">
      <!-- Navbar -->
      <div class="homepage-navbar bg-light shadow  p-3 bg-primary ">
        <div class="d-flex align-items-center">
          <span @click="goBack()" class="text-white">
            <i class="bi bi-arrow-left fs-5"></i>
          </span>
          &nbsp; &nbsp;
          <span>
            <h4 class="text-white">{{ language?.order_details }}</h4>
          </span>
          <div class="d-flex align-items-center gap-2 ms-auto"></div>
        </div>
      </div>

      <!-- Body -->
      <div class="mt-2 my-auto overflow-auto pb-5">
        <div class="container pt-0" ref="captureArea">
          <!-- Laundry Details -->
          <div class="text-center">
            <div class="row">
              <div class="col-4">
            <!--<img  v-if="!imagePreview" :src="loadBase64Image" alt="Order Image" height="100px">-->
            <!-- <img  v-if="!imagePreview && base64Image" :src="base64Image" alt="Order Image" height="100px"> -->
              <img :src="$asset_path+'addlaundry/' +laundry_details.img" alt="Order Image" height="100px"></img>

            </div>
            <div class="col-8">
            <h3 class="p-0 m-0">{{ laundry_details?.name }}</h3> 
            <p class="p-0 m-0">{{ laundry_details?.address }}</p>
            <p class="p-0 m-0"><i class="bi bi-phone"></i> {{ laundry_details?.contact }}</p>
            </div>
            </div>
           
          </div>
          <hr />

          <!-- Order Details -->
          <div class="card-body pt-1">
            <div class="row">
              <div class="col-12">
                <b>{{ language?.order_number }} #{{ order?.billno }}</b>
                <span style="float: right;"><b>{{ language?.create_order_date }} : {{ order?.billdate }}</b></span>
              </div>
              <strong>{{ language?.customer_details }}</strong>
              <div class="col-4">
                <label>{{ language?.create_order_name }}</label>
                <div><b>{{ customer?.name }}</b></div>
              </div>
              <div class="col-4">
                <label>{{ language?.create_cutomer_cell }}</label>
                <div><b>{{ customer?.contact }}</b></div>
              </div>
                <div class="col-4">
                <label>{{ language?.address }}</label>
                <div><b>{{ customer?.address }}</b></div>
              </div>


              <strong>{{ language?.address_details }}</strong>
              <div class="col-4">
                <label>{{ language?.create_order_name }}</label>
                <div><b>{{ address_details?.name }}</b></div>
              </div>
              <div class="col-4">
                <label>{{ language?.create_cutomer_cell }}</label>
                <div><b>{{ address_details?.contact }}</b></div>
              </div>
                <div class="col-4">
                <label>{{ language?.address }}</label>
                <div><b>{{ address_details?.address }}</b></div>
              </div>












              <!--<div class="col-6 pt-2">-->
              <!--  <label class="form-label">{{ language?.create_order_date }}</label>-->
              <!--  <div><b>{{ order?.billdate }}</b></div>-->
              <!--</div>-->
              <div class="col-12 pt-2">
                   <b>{{ (order?.deliverydate )? language?.create_order_delv_date+' : '+order?.deliverydate :'' }}</b> 
              </div>
              <div class="col-12 pt-2">
                   <b> {{ order?.express_charges_status == 1
                    ? language?.express_charges_status + ' : Applied'
                    : ''
                }} / {{ userRow.express_charges }}x </b> 
              </div>
            </div>

            <div class="container bottom_border pt-2 pb-2"></div>

            <!-- Product & Service List -->
            <div class="container">
              <div class="bottom_border row pb-2 text-danger">
                <div class="col-9">
                  <strong>Product & Service</strong>
                </div>
                <div class="col-3">
                  <strong>Cost</strong>
                </div>
              </div>

              <template v-for="(item, i) in orderlist" :key="item.id">
                <div class="bottom_border row" v-if="item.qty != 0">
                  <div class="col-9">
                    <strong>{{ item.productName }}</strong> / {{ item.serviceName +' x '+  item.qty  }}
                    <div>  <span class="text-primary">₹.{{item.rate}}/per</span></div>
                   
                  </div>
                  <div class="col-3">
                    <div class="text-danger">
                      ₹. {{ parseFloat(item.qty) * parseFloat(item.rate) }}
                    </div>
                  </div>
                </div>
              </template>
            </div>
            

            <!-- Summary Section -->
            <div class="row pt-2">
              <div class="col-6">
                <label class="form-label">{{ language?.total_amount }}</label>
                <div><b>₹.{{ order?.total }}</b></div>
              </div>
              <div class="col-6">
                <label class="form-label text-danger" @click="opensidebar()"><span><i class="bi bi-plus-circle-fill me-1"></i></span>{{ language?.paid_amount }}</label>
                <div><b>₹.{{ order?.paid_amt_acc }}</b></div>
              </div>
              <div class="col-12 pt-2" v-if="order?.remark">
                <label class="form-label">{{ language?.remark }}</label>
                <div><b>{{ order?.remark }}</b></div>
              </div>
            </div>

            <hr />
              <div v-if="order && order.img">
                <label>Order Image</label><br>
                <img :src="$asset_path+'order/' +order.img" alt="Order Image" height="100px">
              </div>
            


          </div>
         <text v-if="laundry_details.footermessage"><strong>Terms And Condition.</strong></text>
          <p class="mt-1">{{laundry_details.footermessage}}</p>
          <p class="text-center">Thank You, Visit Again...</p>
        </div>
      
        <div>
        <label class="form-label ms-2">Current Status: {{ order.status }}</label>
        </div>
        <span class="badge bg-warning  text-dark ms-2" @click="updatestatus('processing')">
          <i class="bi bi-watch"></i> &nbsp; Processing
        </span>&nbsp; &nbsp;
        <span class="badge bg-success"@click="updatestatus('completed')">
          <i class="bi bi-cart"></i> &nbsp; Completed
        </span>&nbsp; &nbsp;
        <span class="badge bg-dark text-white" @click="updatestatus('delivered')">
          <i class="bi bi-check"></i> &nbsp; Delivered
        </span>&nbsp; &nbsp;
        <!-- Capture & Share Button -->
        <div class="text-center mt-3">
          <button class="btn btn-primary" @click="captureView">
            <i class="bi bi-share"></i> Capture & Share
          </button>
          <button @click="shareOnWhatsApp" class="btn btn-success" v-if="order?.pdf_file" style="margin-left: 2px;"><i class="bi bi-whatsapp"></i> Share PDF On WhatsApp</button>
        </div>




         <strong v-if="userRow.partial_delivary == 1" class=" ms-2 mt-2">Pending Delivery</strong>
    <div class="container" v-if="userRow.partial_delivary == 1">
              <div class="bottom_border row pb-2 text-danger">
                <div class="col-3">
                   <strong>Product & Service</strong>
                </div>
                <div class="col-3">
                  <strong>Total Qty</strong>
                </div>
                <div class="col-3">
                  <strong>Delivered Qty</strong>
                </div>
                 <div class="col-3">
                  <strong>Pending Qty</strong>
                </div> 
              </div>

              <template v-for="(item, i) in pending_delivery" :key="item.id">
                <div class="bottom_border row" v-if="item.qty != 0">
                  <div class="col-3">
                    <strong> {{ item.productName }}</strong> / {{ item.serviceName +' x '+  item.qty  }}
                    <div>  <span class="text-primary">₹.{{item.rate}}/per</span></div>
                   
                  </div>
                    <div class="col-3">
                    <div class="text-danger">
                       <strong class="text-danger">{{ item.qty }}</strong>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="text-danger">
                       <strong class="text-danger">{{ item.pending_qty }}</strong>
                    </div>
                  </div>
                    <div class="col-3">
                    <div class="text-danger">
                       <strong class="text-danger">{{ item.qty - item.pending_qty }}</strong>
                    </div>
                  </div> 
                </div>
              </template>
            </div>






















      </div>
    </div>
  </div>





        <div class="offcanvas offcanvas-bottom custom_height border-0" tabindex="-1" id="orderDetailsCanvas" 
        aria-labelledby="orderLabel" v-show="view_partial_delivary">
        <div class="offcanvas-header bg-primary d-flex align-items-center justify-content-start gap-3">
          <a href="#" data-bs-dismiss="offcanvas" aria-label="Close"><i
              class="bi bi-arrow-left fs-5 text-white"></i></a>
          <h6 class="offcanvas-title text-white m-0" id="orderLabel">{{language?.create_order_details}}</h6>
        </div>
        <div class="offcanvas-body">


               <div class="container">
              <div class="bottom_border row pb-2 text-danger">
                <div class="col-3">
                  <strong>Product & Service</strong>
                </div>
                <div class="col-3">
                  <strong>Total Qty</strong>
                </div>
                <div class="col-3">
                  <strong>Pending Qty</strong>
                </div>
                <div class="col-3">
                  <strong>Delivery Qty</strong>
                </div>
              </div>

         <template v-for="(item, i) in pending_orderlist" :key="item.id">
                          <div class="bottom_border row"   @click="$refs.qty2[i].focus(); $refs.qty2[i].select()">
                            <div class="col-3">
                              <strong>{{ item.serviceName +' x '+  item.qty }}</strong>
                              <div>
                                {{ item.productName }}
                                <span class="text-primary">₹.{{item.rate}}/per</span>
                              </div>
                            </div>

                             <div class="col-3 mt-1">
                           
                             <span class="text-danger">{{ item.display_qty2 }}</span>

                            </div>

                            <div class="col-3 mt-1">
                           
                             <span class="text-danger">{{ item.remaining_qty }}</span>

                            </div>

                          <!-- <div class="col-3">
                              <input type="number"
                               ref="qty2"
                                min="0"
                                class="form-control text-danger"
                                v-model.number="item.remaining_qty"
                                placeholder="Qty"
                                 @input="item.remaining_qty = (item.remaining_qty > item.remaining_qty ? item.remaining_qty : item.remaining_qty)"
                                 @focus="item.remaining_qty = item.remaining_qty ?? item.remaining_qty"
                                >
                            </div>    -->

                            <div class="col-3">
                                  <input
                                    type="number"
                                    ref="qty2"
                                    class="form-control text-danger"
                                    v-model.number="item.input_qty"
                                    :min="0"
                                    :max="item.remaining_qty"
                                    placeholder="Qty"
                                    @input="item.input_qty = clamp(item.input_qty, 0, item.remaining_qty)"
                                  >
                                </div>






                            


                          </div>
                        </template>

            </div>

         

        </div>
         <div class="offcanvas-footer">
             <!--<button class="btn btn-success col-12" v-if="selected_services && selected_services.length>0" @click="confirmCosts">-->
             <button class="btn btn-success col-12"  @click="saveOrder">
              <i class="bi bi-check"></i> &nbsp;{{language?.save}}
            </button>
         </div>
      </div>






            <div class="offcanvas offcanvas-end border-0" tabindex="-1" id="showvoucher" aria-labelledby="voucherLabel">
                      <div class="offcanvas-header bg-primary d-flex align-items-center justify-content-start gap-3">
                        <a href="#" data-bs-dismiss="offcanvas" aria-label="Close"><i class="bi bi-arrow-left fs-5 text-white"></i></a>
                        <h6 class="offcanvas-title text-white m-0" id="voucherLabel">Add Voucher</h6>
                      </div>
                      <div class="offcanvas-body">
                        
                            
                                <div class="mb-3">
                                    <label for="date" class="form-label">Date</label>
                                    <input type="date" id="date" v-model="voucher.billdate" class="form-control" required>
                                </div>

                                <div class="mb-3">
                                  <label for="amount" class="form-label">Amount</label>
                                  <input type="number" id="amount" v-model="voucher.paid" class="form-control" required>
                              </div>

                              <div class="mb-3">
                                  <label for="remark" class="form-label">Remark</label>
                                  <textarea id="remark" v-model="voucher.remark" class="form-control" rows="2" required></textarea>
                              </div>
                              
                                
                              <div class="d-flex gap-2">
                                  <button class="btn btn-primary w-100 " @click="updatevoucher()">Save</button>
                                
                              </div>
                              
                      </div>
                  </div>




  













</template>

<style>
.bottom_border{
        border-bottom: 1px solid gray;
}
.footer_area{
        position: fixed;
        width: -webkit-fill-available;
        bottom: 0;
        background: aliceblue;
        padding: 5px 10px;
}
    .custom_height {
           min-height: 80vh;
        max-height: 80vh;
        overflow-y: auto;
    }
</style>
<script>
import axios from "@/plugins/axios"; 
import html2canvas from "html2canvas";
 
  export default {
    name: 'OrderDetails',
    components: {
    },
    
    
    mounted() {
      //  this.fetchWeather();
      if(this.$route.query.id)
            this.getOrderDetails(this.$route.query.id); // Call the method here

    }, 
    data() {
      return { 
        whatsappdeliverymeg:'',
        loading: false,
        error: null,
        orderlist:[],
        order:[],
        customer:[],
        laundry_details:[],
        language:this.getLocalStorageArray('lang'),
        base64Image: null,
        pdfBlobUrl: "", 
        assetpath:'',
        pdf_file:'',
        userRow:[],
        view_partial_delivary:false,
        partial_delivary: [],
        getorderid:'',
        pending_delivery:[],
        pending_orderlist:[],
        balance:[],
        address_details:[],
        display_qty2: 0,
        remaining_qty:0,
        input_qty:0,

          voucher:{
            id:'',
            billdate:new Date().toISOString().split('T')[0],
            paid:'',
            remark:'',
            orderid:''

          },






      }
    },
   
    methods: {
      initializeHomeContent() {


      },
  async generatePDF() {
        
    },
     
            shareOnWhatsApp() {
            //   if (!this.pdfBlobUrl) {
            //     console.error("No PDF available to share.");
            //     return;
            //   }
            if(this.customer?.contact){
                  let phoneNumber = this.customer?.contact || "91XXXXXXXXXX"; // Customer's contact number
                  if(phoneNumber.length==10)
                        phoneNumber="91"+phoneNumber;
                        

                  const balance = this.balance ?? 0; // <-- yaha se balance liya

                  // const message = `Hello, here is your laundry bill. Please download it from: ${this.assetpath+""+this.order.pdf_file}`;
                  // const message = `${this.whatsappdeliverymeg} ${this.assetpath}${this.order.pdf_file}`;
                   const message = `${this.whatsappdeliverymeg} ${this.assetpath}${this.order.pdf_file}\n\nBalance: ₹${balance}`;


                   

   
                  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
                
                  // Open WhatsApp
                //   window.open(whatsappUrl, "_blank");
                window.location.href = whatsappUrl;
                }
            }, 
      goBack() {
          
          this.$router.go(-1);
  },
        
        
         async convertImageToBase64(url) {
                    try {
                      const response = await fetch(url);
                      const blob = await response.blob();
                      return new Promise((resolve) => {
                        const reader = new FileReader();
                        reader.onloadend = () => resolve(reader.result);
                        reader.readAsDataURL(blob);
                      });
                    } catch (error) {
                      console.error("Error converting image to Base64:", error);
                      return null;
                    }
                  },
                
                  async loadBase64Image() {
                    const imageUrl = this.$asset_path + "addlaundry/" + this.laundry_details.img;
                    // alert(imageUrl);
                    this.base64Image = await this.convertImageToBase64(imageUrl);
                  },
                  
                  
                  
                  
       async captureView() {
  const element = this.$refs.captureArea;

  // Wait for all images to load before capturing
  const images = element.getElementsByTagName("img");
  await Promise.all(
    Array.from(images).map((img) => {
      return new Promise((resolve, reject) => {
        if (img.complete) resolve(); // Image is already loaded
        img.onload = resolve;
        img.onerror = reject;
      });
    })
  );

  // Capture with html2canvas
  html2canvas(element, {
    useCORS: true, // Allow cross-origin images
    logging: true,
    scale: 2, // Improve image quality
  }).then((canvas) => {
    canvas.toBlob((blob) => {
      if (!blob) return;

      const file = new File([blob], "bill_print.png", { type: "image/png" });

      // Web Share API support check
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        navigator
          .share({
            title: "Order No: #" + this.order.id, // Fix self.order to this.order
            text: this.share_msg,
            files: [file],
          })
          .catch((err) => console.error("Sharing failed", err));
      } else {
        // Fallback: Download image
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "bill_print.png";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }, "image/png");
  });
},

      
        
      async getOrderDetails(orderid) {
        this.loading = true;
        this.error = null;

        try {
          var self = this;




          axios.post("getOrderDetails",{orderid:orderid}).then((response) => {
            

            


            self.orderlist = response.data.orderlist;
            self.pending_orderlist = response.data.pending_orderlist;
            self.order = response.data.order;
            self.customer = response.data.customer;
            self.assetpath = response.data.assetpath;
            self.laundry_details = response.data.laundry_details;
            self.whatsappdeliverymeg = response.data.laundry_details.delv_message;
            self.userRow = response.data.userRow;
            self.pending_delivery = response.data.pending_delivery;
            self.balance = response.data.getbalance.balance;


             self.address_details = response.data.address_details;





            self.voucher.orderid = orderid;
           
            
                     self.language=response.data.language;
                     localStorage.setItem('lang',response.data.language);

                     self.getorderid = orderid;

                     self.pending_orderlist.forEach(item => {
                  item.qty2 = item.qty;
                  item.display_qty2 = item.qty;   // <- qty2 ko qty ke equal set
                  item.remaining_qty = item.qty - item.pending_qty; 
                  item.input_qty = item.qty - item.pending_qty; 
                });



             




          }).then(() => { 
               self.loadBase64Image(); 
          }).catch((err) => {

          });;


        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      },


      async updatestatus(status="") {
        this.loading = true;
        this.error = null;
        

        try {
          var self = this;

           if (status.trim().toLowerCase() === "delivered" && self.userRow.partial_delivary == 1)  {


            
             self.view_partial_delivary = true;
      
              this.$nextTick(() => {
                  let offcanvasEl = document.getElementById('orderDetailsCanvas');
                  let bsOffcanvas = new bootstrap.Offcanvas(offcanvasEl);
                  bsOffcanvas.show();
              });


           }else{

          axios.post("updatestatus",{orderid:self.order.id,status:status}).then((response) => {
            
            self.orderlist = response.data.orderlist;
            self.order = response.data.order;
            self.laundry_details = response.data.laundry_details;
            self.$swal.fire(response.data.message);
            
                     self.language=response.data.language;
                     localStorage.setItem('lang',response.data.language);

                           if(self.order.status === 'delivered'){ 
                                    self.getOrderDetails();
                                    window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("showvoucher")).hide();
                                    self.shareOnWhatsApp();

                                }

          }).then(() => { 
          }).catch((err) => {

          });;

          }


        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      },




      
      getLocalStorageArray(key) {
        let data = localStorage?.getItem(key);
        try {
            return data ? JSON.parse(data) : [];
        } catch (e) {
            console.error("Error parsing localStorage data", e);
            return [];
        }
    },

    saveOrder(){

        this.loading = true;
        this.error = null;
        

        try {
          var self = this;

           self.partial_delivary = [];

           

            self.pending_orderlist.forEach(item => {
              
              if (item.qty && item.qty != 0) {
                this.partial_delivary.push({
                  id: item.id,
                  qty: item.qty2,
                  remaining_qty :item.input_qty,
                });
              }
            });

          axios.post("save_partial_delivery",{
              orderid: self.getorderid,              // <-- send order id
              partial_delivary: self.partial_delivary  // <-- send items array
            }).then((response) => {


            
            self.orderlist = response.data.orderlist;
            self.pending_orderlist = response.data.pending_orderlist;
            self.order = response.data.order;
            self.laundry_details = response.data.laundry_details;
            self.balance = response.data.getbalance.balance;
            self.$swal.fire(response.data.reply);
            
                     self.language=response.data.language;
                     localStorage.setItem('lang',response.data.language);

                           if(self.order.status === 'delivered'){ 
            self.shareOnWhatsApp();
        }

          }).then(() => { 
          }).catch((err) => {

          });


          } catch (err) {
            this.error = err.response?.data?.message || "Login failed. Please try again.";
          } finally {
            this.loading = false;
          }



      },

        clamp(value, min, max) {
          value = Number(value) || 0;
          return Math.min(Math.max(value, min), max);
        },

        opensidebar(){
           window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("showvoucher")).show();
        },


        
      updatevoucher() {
              this.loading = true;
              this.error = null;

              try {
                  var self = this;
                  if (self.voucher.amount == '') {
                      self.$swal.fire("Amount is empty");
                  } else {
                      axios.post("addcustaccounting", self.voucher).then((response) => {
      
                             self.order = response.data.order;

                          self.$swal.fire(response.data.message);
                          if (response.data.success) {
                              self.voucher = { voucher_date: '', amount: '', remark: '', custid: 0 };
                          }
                          
                          window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("showvoucher")).hide();
                      }).then(() => {
                          self.initializeHomeContent();
                      });
                  }
              } catch (error) {
                  console.error(error);
                  self.$swal.fire("An error occurred while saving the voucher.");
              } finally {
                  this.loading = false;
              }
          },



























    }
  }






</script>